<swap-modal [modalId]="modalId" [centered]="true">
  <div class="row m-3">
    <div class="col-12 d-flex mb-3">
      <h5 class="modal-title mb-0 fw-bolder" id="exampleModalLabel">
        Confirm Transfer
      </h5>
      <button
        type="button"
        class="closeBtn d-none"
        data-bs-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <img loading="lazy" src="assets/icons/close-icon.svg" alt="" />
      </button>
    </div>
    <div class="col-12 mb-2">
      <p>
        <b class="text-muted">ex3F5T7U9L</b> is trying to confirm if you’ve
        received the payment made. Please double check payment receipt from your
        bank before clicking confirm.
      </p>
      <p class="mb-0">if yes, click <b>confirm</b> to approve payment.</p>
      <div class="d-flex align-items-center gap-2 mt-4">
        <button
          (click)="emitTransferConfirmation.emit(false); closeBtn.click()"
          class="submit-btn fw-700 font-13 btn-decline"
        >
          Cancel
        </button>
        <button
          class="submit-btn fw-700 font-13"
          (click)="emitTransferConfirmation.emit(true); closeBtn.click()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</swap-modal>
